// src/app/core/services/notificaciones.model.ts

export type NotificacionTipo =
  | "QUOTE_PRICED"
  | "QUOTE_SUBMITTED"
  | "ORDER_STATUS"
  | "INVOICE_READY"
  | "LOW_STOCK";

export interface Notificacion {
  id: number;
  userId: number;
  type: NotificacionTipo;
  title: string;
  message: string;
  link: string | null;
  read: boolean;
  createdAt: string;
}

export interface RespuestaPaginadaNotificaciones {
  page: number;
  limit: number;
  total: number;
  items: Notificacion[];
}

export const NOTIFICACION_ICON: Record<NotificacionTipo, string> = {
  QUOTE_PRICED: "bx-dollar-circle",
  QUOTE_SUBMITTED: "bx-cart",
  ORDER_STATUS: "bx-package",
  INVOICE_READY: "bx-receipt",
  LOW_STOCK: "bx-error",
};
